export enum Tabs {
  Property = 'Property',
  Name = 'Name',
  Other = 'Other',
  Multi = 'Multi',
  Links = 'Links',
}

export enum SearchTypes {
  Property = 'searchByProperty',
  Name = 'searchByName',
  Other = 'searchByOther',
  Multi = 'searchByMulti',
}

export enum OtherTabSearchBy {
  DOCUMENTS = 'recordedDocuments',
  LIENS = 'liens',
  UNIFORM_COMMERCIAL = 'uniformCommercialCodes',
  ENVIRONMENTAL_CONTROL = 'environmentalControlBoardJudgments',
  EMERGENCY_REPAIRS = 'emergencyRepairs',
}

export enum OtherTabFieldNames {
  SEARCHBY = 'otherTab.searchBy',
  REEL = 'otherTab.reel',
  FILE_NUMBER = 'otherTab.fileNumber',
  CRFN = 'otherTab.crfn',
  PAGE = 'otherTab.page',
  CONTROL_NUMBER = 'otherTab.controlNumber',
  DOCUMENT_ID = 'otherTab.documentId',
  ADDRESSES = 'otherTab.addresses',
}

export const initialCorporations = [
  {
    name: '',
    items: [''],
  },
  {
    name: '',
    items: [''],
  },
];

export const initialAliases = [
  {
    name: '',
    items: [
      {
        firstName: '',
        lastName: '',
        isExactLastName: false,
      },
    ],
  },
  {
    name: '',
    items: [
      {
        firstName: '',
        lastName: '',
        isExactLastName: false,
      },
    ],
  },
  {
    name: '',
    items: [
      {
        firstName: '',
        lastName: '',
        isExactLastName: false,
      },
    ],
  },
  {
    name: '',
    items: [
      {
        firstName: '',
        lastName: '',
        isExactLastName: false,
      },
    ],
  },
];

export const initialAddresses = [
  {
    houseNumber: '',
    street: '',
  },
];

const initialNameForm = {
  judgmentsLiens: true,
  ftl: true,
  parkingViolations: true,
  ecb: true,
  tab: true,
  ucc: false,
  recordedDocuments: false,
  searchByIndividual: false,
  searchByCorporation: false,
  acris: false,
  corporations: initialCorporations,
  aliases: initialAliases,
};

export const initialForm = {
  hob: '',
  tab: Tabs.Property,
  from: '',
  to: '',
  bookType: '',
  apn: '',
  searchName: '',
  propertyTab: {
    assessment: false,
    recordedDocuments: false,
    filedLiens: true,
    searchBy: 'parcel',
    block: '',
    lot: '',
    ease: '',
    houseNumber: '',
    street: '',
    apartmentNumber: '',
    ownerName: '',
  },
  nameTab: initialNameForm,
  otherTab: {
    searchBy: 'recordedDocuments',
    documentId: '',
    crfn: '',
    reel: '',
    page: '',
    fileNumber: '',
    controlNumber: '',
    year: '',
    indexNumber: '',
    addresses: initialAddresses,
  },
  multiTab: {
    searchByBlockLot: false,
    assessment: false,
    recordedDocumentsByBlockLot: false,
    filedLiens: true,
    block: '',
    lot: '',
    ease: '',
    searchByName: false,
    ...initialNameForm,
    searchByAddress: false,
    ecbsByAddress: false,
    emergencyRepairs: false,
    addresses: initialAddresses,
  },
};

export const locations = [
  { name: 'New York', value: 'NY065001000' },
  { name: 'Bronx', value: 'NY065002000' },
  { name: 'Kings', value: 'NY065003000' },
  { name: 'Queens', value: 'NY065004000' },
  { name: 'Richmond', value: 'NY065005000' },
];

export const bookTypeOptions = [
  { value: '', text: 'All' },
  { value: '01', text: '01 - Judgments and Hospital Liens' },
  { value: '02', text: '02 - Hospital Liens' },
  { value: '03', text: '03 - Mechanics Lien' },
  { value: '04', text: '04 - Building Loan' },
  { value: '05', text: '05 - Lis Pendens' },
  { value: '06', text: '06 - Sidewalk Lien' },
  // { value: '07', text: '07 - Federal Tax Lien' },
  { value: '08', text: '08 - In Rems' },
  { value: '09', text: '09 - Notice of Tax Lien Sale' },
  { value: '10', text: '10 - Judgments' },
  { value: '11', text: '11 - Mech/BL/LP/SW' },
];
export const NYC_DB_FORM_NAME = 'newYorkCityDataBase';
